import React from 'react';
import { AlertCircle, MessageSquare } from 'lucide-react';
import '../styles/Header.css';

const Header = ({ params, paramsError }) => {
  return (
    <div className="header-card">
      <div className="header-title">
        <MessageSquare className="header-icon" size={28} />
        <h1>Comments</h1>
      </div>
      
      <div className="header-params">
        <div className="param-item">
          <span className="param-label">Time:</span>
          <span className="param-value">{params.period}</span>
        </div>
        <div className="param-item">
          <span className="param-label">RA:</span>
          <span className="param-value">{params.retailAssoc}</span>
        </div>
        <div className="param-item">
          <span className="param-label">COA:</span>
          <span className="param-value">{params.coa}</span>
        </div>
      </div>
      
      {paramsError && (
        <div className="error-banner">
          <AlertCircle size={20} />
          <span>Passing in time period, retail association and COA is mandatory.</span>
        </div>
      )}
    </div>
  );
};

export default Header;